import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgPriorityLow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.75 3.25L10.75 13.8775L13.4425 11.1925L14.5 12.25L10 16.75L5.5 12.25L6.5575 11.1925L9.25 13.8775L9.25 3.25L10.75 3.25Z",
		fill: "inherit"
	})
});
export default SvgPriorityLow;
